import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'; 
import qs from 'qs';
import styled from 'styled-components';
import server from 'server/serverController2';
 
import CommentItem from 'components/containers/comment/list/CommentItem'; 
import BottomTextArea from 'components/containers/input/BottomTextArea';

import shrinkReplyIcon from 'images/icon/arrow_up_707070-16×10.png'
import expandReplyIcon from 'images/icon/arrow_down_707070-16×10.png'
import { removeItem } from 'utils/utils';

export default function CommentReplyList({
											insertedItemList,updatedItem, deletedItem, 
											parentListType, parentListItemType,
											type, parentNo, targetNo, initReplyList, totalReply, limit=20,
											loadNext,setLoadNext,
											onReplyInserted, onReplyDeleted, onReplyUpdated
										}) { 
  const userInfo = useSelector((state) => {
      return state.userInfo
  })
	const [replyList, setReplyList] = useState([]);
	const [insertedReplyList, setInsertedReplyList] = useState([]); 
	const [lastPosNo, setLastPosNo] = useState(null);
	const [isInserting, setIsInserting] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isEnd, setIsEnd] = useState(false);


	const [replyContent, setReplyContent] = useState('');
    const [currBottomInputHeight, setCurrBottomInputHeight] = useState(70);
    const [bottomInputFocus, setBottomInputFocus] = useState(false);

	//reply display state
	const [hideReply, setHideReply] = useState(false);
	const [remainedReplyNum, setRemainedReplyNum] = useState(null);

	let getReplyEndPoint;
	let createReplyEndPoint;
	if(targetNo && parentNo && type)
	{
		if(type === 'campaign_post')
		{
			getReplyEndPoint=`campaigns/posts/${targetNo}/comments`
			createReplyEndPoint=`campaigns/posts/${targetNo}/comments`
		}	
	}
	
	useEffect(()=>{
		if(initReplyList && initReplyList?.length > 0)
		{
			if(replyList.length === 0)
			{
				setLastPosNo(initReplyList[initReplyList.length - 1]['no']);
				setReplyList(initReplyList);
				if(totalReply > 0)
				{
					setRemainedReplyNum(totalReply- initReplyList.length );
				}
			}
			else
			{
				const updatedReplyList = [...replyList];
				//setReplyList
				let isModified = false;
				for(let i = 0; i < initReplyList.length; ++i)
				{
					for(let j = 0; j < updatedReplyList.length; ++j)
					{
						if(parseInt(updatedReplyList[j]['no']) === parseInt(initReplyList[i]['no']))
						{
							updatedReplyList[j]={
								...updatedReplyList[j],
								...initReplyList[i]
							}
							isModified=true;
						}
					}	
				}
				if(isModified === true)
				{
					setReplyList(updatedReplyList)
				}
			}
			
		}
	},[initReplyList]);
	useEffect(()=>{
		setInsertedReplyList([...insertedItemList]);
	},[insertedItemList])

	useEffect(()=>{
		if(![null, undefined].includes(deletedItem))
		{
			removeFromList(deletedItem['no']);
		}

	},[deletedItem])
	useEffect(()=>{
		if(![null, undefined].includes(updatedItem))
		{
			updateFromList(updatedItem);	
		}
		
	},[updatedItem])
	useEffect(()=>{
		if(loadNext === true)
		{
			loadComment();
			setLoadNext(false);
		} 
	},[loadNext])

	const loadComment = () => {
		if(getReplyEndPoint)
		{
			let queryString = {}
			queryString['parent_no'] = parentNo;
			queryString['last_pos_no'] = lastPosNo;
			queryString['limit'] = limit;
			queryString['get_total_like'] = true;
			queryString['get_total_reply'] = true;
			queryString['show_comment_reply'] = true;
			queryString = qs.stringify(queryString);
			server.getRequestData(`${getReplyEndPoint}?${queryString}`, (res)=>{
				try
				{
					const resData = res.data;
					const receivedReply = resData['comments'];

					if(receivedReply.length > 0)
					{
						setReplyList([...replyList, ...receivedReply])
						setLastPosNo(receivedReply[receivedReply.length - 1]['no']);
					}
					else
					{
						setIsEnd(false);
					}
					setIsLoading(false);
					setRemainedReplyNum(remainedReplyNum-limit)
				}
				catch(err)
				{
					console.log(err);
				}
			})
		}
	}

	const submitCommentReply = ()=>{
		if(createReplyEndPoint && isInserting === false)
		{
			setIsInserting(true)
			let form = {}
			form['content'] = replyContent;
			form['parent_no'] = parentNo;
			server.postRequestData(`${createReplyEndPoint}`,form ,(res)=>{
				try
				{
					setIsInserting(false)
					const resData = res.data;
					const insertedReply = resData['inserted_item']; 
					insertedReply['nickname'] = userInfo['name'];
					insertedReply['profile_img'] = userInfo['profile_img'];
					insertedReply['total_comment'] = 0;
					insertedReply['liked_comment'] = false;
					insertedReply['total_like'] = 0;
					if(onReplyInserted)
					{
						onReplyInserted(insertedReply)	
					}
					setReplyContent('');
					setInsertedReplyList([...insertedReplyList,insertedReply])
				}
				catch(err)
				{
					setIsInserting(false)
					console.log(err);
				}
			})
		}
	}
	const handleUpdateReply = (updatedItem) => { 
		const newReplyList = [...replyList]
		const newInsertedReplyList = [...insertedReplyList]
		let isUpdated = false;
		for(let i = 0; i < newReplyList.length; ++i)
		{
			if(parseInt(newReplyList[i]['no']) === parseInt(updatedItem['no']))
			{
				isUpdated = true;
				newReplyList[i] = {
					...newReplyList[i],
					...updatedItem
				}
			}
		}
		if(isUpdated)
		{
			setReplyList(newReplyList);
		}

		isUpdated = false;
		for(let i = 0; i < newInsertedReplyList.length; ++i)
		{
			if(parseInt(newInsertedReplyList[i]['no']) === parseInt(updatedItem['no']))
			{
				isUpdated = true;
				newInsertedReplyList[i] = {
					...newInsertedReplyList[i],
					...updatedItem
				}
			}
		}
		if(isUpdated)
		{
			setInsertedReplyList(newInsertedReplyList);
		}

		if(onReplyUpdated)
		{
			onReplyUpdated(updatedItem)
		}
	}

	const removeFromList = (commentNo) => {
		let newList = [...replyList];
		for(let i = 0; i < newList.length; ++i)
		{
			if(parseInt(newList[i]['no'])===parseInt(commentNo))
			{
				newList = removeItem(newList, i)
			}
		}
		setReplyList(newList);


		let newInsertedList = [...insertedReplyList];
		for(let i = 0; i < newInsertedList.length; ++i)
		{
			if(parseInt(newInsertedList[i]['no'])===parseInt(commentNo))
			{
				newInsertedList = removeItem(newInsertedList, i)
			}
		}
		setInsertedReplyList(newInsertedList);
	}

	const updateFromList = (updatedItem) => {
		let newList = [...replyList];
		let newInsertedList = [...insertedReplyList];
		for(let i = 0; i < newList.length; ++i)
		{
			if(parseInt(newList[i]['no'])===parseInt(updatedItem['no']))
			{
				newList[i] = {
					...newList[i],
					...updatedItem 
				}
			}
		}
		setReplyList(newList);


		for(let i = 0; i < newInsertedList.length; ++i)
		{
			if(parseInt(newInsertedList[i]['no'])===parseInt(updatedItem['no']))
			{
				newInsertedList[i] = {
					...newInsertedList[i],
					...updatedItem 
				}
			}
		}
		setInsertedReplyList(newInsertedList);

	}
	return (
		<div>
			{
				(hideReply===false &&  
					(replyList.map((reply)=>{
						const isInsertedItem = (insertedReplyList.filter((insertedItem)=>{ 
													if(parseInt(insertedItem['no'])===parseInt(reply['no']))return true;
												}).length > 0);
						return(
							<React.Fragment key={`reply-list-comment-item-wrapper-${reply['no']}`} >
								{(!isInsertedItem &&
									<CommentItem 
										key={`reply-list-comment-item-${reply['no']}`} 
										type={type}
										listType={parentListType}
										listItemType={`${(parentListType==='comment_list')?'comment_list_reply':'reply_list_item'}`}
										comment={reply} 
										wrapperStyle={{marginBottom : `calc(100vw*(14/375))`}} 
										onUpdateComment={handleUpdateReply}
										onDeleteComment={(deletedItem)=>{ 
											removeFromList(deletedItem['no'])
											onReplyDeleted(deletedItem);
										}}
									/>
								)}
							</React.Fragment>
							)
					}))
				)
			}
			{	(totalReply && replyList.length > 0)
				?(	
					(remainedReplyNum > 0)
					?(
						<ReplyActionBtn  
						onClick={()=>{loadComment()}}>
							{`답글 ${remainedReplyNum}개 더보기`}
							<ReplyActionBtnIcon src={expandReplyIcon} />
						</ReplyActionBtn>)
					:(
						(hideReply === true)
						?(
							<ReplyActionBtn onClick={()=>{setHideReply(false)}}>{`답글 보기`}
								<ReplyActionBtnIcon src={expandReplyIcon} />
							</ReplyActionBtn>
						)
						:(<ReplyActionBtn onClick={()=>{setHideReply(true)}}>{`답글 숨기기`}
								<ReplyActionBtnIcon src={shrinkReplyIcon} />
							</ReplyActionBtn>)
						)
					)
				:(null) 
			} 

			{
				(insertedReplyList.map((reply)=>{
					return(
						<CommentItem 
						listType={parentListType}
						listItemType={`${(parentListType==='comment_list')?'comment_list_reply':'reply_list_item'}`}
						type={type}
						key={`reply-list-inserted-comment-item-${reply['no']}`} 
						comment={reply} 
						wrapperStyle={{marginBottom : `calc(100vw*(14/375))`}} 
						onUpdateComment={handleUpdateReply}
						onDeleteComment={(deletedItem)=>{ 
							removeFromList(deletedItem['no'])
							onReplyDeleted(deletedItem);
						}}
						/>
						)
				}))
			}
			{
				((parentListItemType === 'reply_list_parent') && (
					<>
						<Spacer currHeight={currBottomInputHeight} />
						<BottomTextArea 
						maxRow={5} minRow={1}
						onChange={(value) => {setReplyContent(value)}}
						onSubmit={submitCommentReply} 
						textAreaStyle={{lineHeight: '20px', color: 'black'}} 
						onHeightChange={(height) => {
							setCurrBottomInputHeight(height);
						}}
						bottomInputFocus={bottomInputFocus}
						setBottomInputFocus={setBottomInputFocus}
						displayType={'absolute'} />
					</>
				))

			}
		</div>
	);
}

const Spacer = styled.div`
  height: ${({currHeight}) => currHeight && `${currHeight}`}px;
  min-height: ${({currHeight}) => currHeight && `${currHeight}`}px;
  margin-top: calc(100vw * (35 / 375));
`;
const ReplyActionBtn = styled.span`
	display:flex;
	margin-bottom:calc(100vw*(12/375));
	align-items: center;
	font-style: normal;
	font-weight: 500;
	font-size: calc(100vw*(11/375));
	color: #707070;
`;
const ReplyActionBtnIcon = styled.img`
	margin-left :calc(100vw*(6/375));
	width : calc(100vw*(8/375));
	height : calc(100vw*(5/375));
`